import { render, staticRenderFns } from "./collab_task_edit.vue?vue&type=template&id=0bb3d36a&scoped=true"
import script from "./collab_task_edit.vue?vue&type=script&lang=js"
export * from "./collab_task_edit.vue?vue&type=script&lang=js"
import style0 from "./collab_task_edit.vue?vue&type=style&index=0&id=0bb3d36a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb3d36a",
  null
  
)

export default component.exports